export default __webpack_public_path__ + "static/media/test-assignment-zechmann-hero-it.6c589205.png";